module.exports = __webpack_public_path__ + "img/index7.25bb5ac7.png";